import { useSales } from '@recargas-dominicanas/core/store';
import { style } from './balance.module.css';
import { Icon } from '@recargas-dominicanas/core/components';
import { useNavigate } from 'react-router-dom';

export function Balance() {

  const salesStore = useSales();
  const navigate = useNavigate();

  function handleClick() {
    navigate('/ventas');
  }

  return (
    <div className={style.container} onClick={handleClick}>
      <span className={style.title}>Balance</span>
      <span className={style.value}>
        RD$ {Intl.NumberFormat('es-DO').format(salesStore.balance)}
      </span>
      <Icon icon='chevron_right' className={style.icon}/>
    </div>
  );
}
